<style scoped lang="scss">
@import '$vars';
.container {
  flex-direction: column
}
figure {
  position: absolute;
  top: 0;
  text-align: center;
  img {
    width: 120%;
    margin-left: -10%;
    margin-top: -1em;
  }
}
.card {
  margin-top: 6em;
  background-color: $color-purple;
  color: white;
  border: 0;
  z-index: 0;
  header {
    border-bottom: 1px solid white
  }
  footer {
    margin: 1em 0
  }
}
h2 {
  font-size: 1em
}

main>div.has-icon-right.col-6 {
  width: 100% !important;
}

</style>

<template>
  <main>
   <transition name="fade" mode="out-in" tag="main">
      <form @submit.prevent="changePw"  v-if="tokenValid && loaded">
        <header class="card-header">
          <h2 class="text-center">Alteração de senha</h2>
        </header>
        <main class="card-body">
          <dr-field
            prefix="pw"
            v-for="(field, name) in passwords"
            v-bind:form.sync="passwords"
            v-bind:field.sync="field"
            v-bind:value.sync="passwords[name].value"
            v-bind:validators.sync="$v.passwords[name]"
            v-bind:apiErrors.sync="apiErrors[name]"
            :key="name">
          </dr-field>
        </main>
        <footer class="card-footer">
          <div class="column form-group">
            <dr-submit text="Alterar senha" class="btn btn-primary" :sending="sendingPw"></dr-submit>
          </div>
          <p class="text-center"><br /><router-link to="/login" class="flex-center">Voltar para login</router-link></p>
        </footer>
      </form>
      <dr-loader v-else size="lg"></dr-loader>
    </transition>
  </main>
</template>

<script>
import drField from '@/components/form/field.vue'
import drSubmit from '@/components/form/submit.vue'
import {passwords, validationsPw} from '@/data/formData/password.js'

export default {
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      loaded: false,
      passwords: passwords,
      email: null,
      sendingPw: false,
      tokenValid: false,
      apiErrors: {
        password: []
      }
    }
  },
  validations: {
    passwords: validationsPw
  },
  mounted () {
    this.$http.get(`/remember_password/${this.$route.params.token}`).then(
      (res) => {
        if (res.data) {
          this.tokenValid = true
          this.loaded = true
        } else {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Token inválido!',
            size: 'md',
            active: true,
            callback: () => {
              this.$router.replace('/login')
            }
          })
        }
      }
    ).catch(
      () => {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Token inválido!',
          size: 'md',
          active: true,
          callback: () => {
            this.$router.replace('/login')
          }
        })
      }
    )
  },
  methods: {
    changePw () {
      this.$v.passwords.$touch()
      if (this.$v.passwords.$invalid) {
        return
      }
      this.fn_SHOW_PROGRESS()
      this.sendingPw = true
      let plainPassword = {
        first: this.passwords.password.value,
        second: this.passwords.passwordConfirm.value
      }
      this.$http.put(`/remember_password/${this.$route.params.token}`, {'change_password': { 'plainPassword': plainPassword }}).then(
        (res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Atualização de dados',
            body: 'Senha atualizada com sucesso!',
            size: 'md',
            active: true,
            callback () {
              this.$router.replace('/')
            }
          })
          this.edit = false
          this.sendingPw = false
          this.fn_HIDE_PROGRESS()
        }).catch(
        (err) => {
          console.log(err)

          const msg = (typeof err !== 'object')
            ? null
            : ('errors' in err)
              ? this.findErrorMessage(err.errors)
              : null

          if (msg) {
            this.$store.dispatch('setModalAlert', {
              title: 'Ocorreu um erro',
              body: msg[0],
              size: 'md',
              active: true,
              callback () {
                this.$router.replace('/')
              }
            })
          } else {
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }

          this.sendingPw = false
          this.fn_HIDE_PROGRESS()
          this.$router.replace('/')
        }
      )
    },

    findErrorMessage (object) {
      let errorMessage = null

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => {
          if (typeof element === 'object') {
            recursiveSearch(element)
          } else {
            errorMessage = element
          }
        })
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    }
  }
}
</script>
